// ====== UTILITY FUNCTIONS ======
function debounce(func, wait, immediate) {
  let timeout;
  return function(...args) {
    const later = () => {
      timeout = null;
      if (!immediate) func(...args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func(...args);
  };
}

// ====== THEME INITIALIZATION ======
document.addEventListener('DOMContentLoaded', function() {

  // Mobile Menu Toggle
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
    });
  }

  // Search Toggle
  const searchToggle = document.querySelector('.search-toggle');
  const searchBar = document.querySelector('.search-bar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function() {
      searchBar.classList.toggle('active');
    });
  }

  // ====== SMOOTH SCROLLING ======
  function initSmoothScroll() {
    const header = document.querySelector('.custom-header');
    const headerHeight = header ? header.offsetHeight + 20 : 100;
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#' || targetId === '#!') return;
        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          const offsetPosition = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - headerHeight);
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
          history.pushState(null, null, targetId);
        }
      });
    });
  }

  initSmoothScroll();
  window.addEventListener('resize', debounce(initSmoothScroll, 250));
});